var map = {
	"./i/logo.svg": "3a78",
	"./ii/logo.svg": "f00a",
	"./iii/logo.svg": "b544",
	"./iv/logo.svg": "854b",
	"./ix/logo.svg": "cffe",
	"./v/logo.svg": "7ff0",
	"./vi/logo.svg": "9e43",
	"./vii/logo.svg": "664e",
	"./viii/logo.svg": "775d",
	"./x/logo.svg": "a344",
	"./xi/logo.svg": "f18d",
	"./xii/logo.svg": "80ec"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "547d";